import React, { useCallback, useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, SaveIcon } from 'lucide-react';
import { InfoTip } from '../../../ui/InfoTip';
import { AnchoredPopover } from '../../../ui/AnchoredPopover';
import { ProfileIcon } from '../../../icons/ProfileIcons';
import { ProfileMenu } from './ProfileMenu';
import { SaveProfileModal } from './SaveProfileModal';
import { ManageProfilesModal } from './ManageProfilesModal';
import { useSupportProfiles } from '../../../../hooks/useSupportProfiles';
export function ProfileBar() {
  const profiles = useSupportProfiles();
  const rowRef = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [modal, setModal] = useState<'save' | 'manage' | null>(null);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const {
    active,
    isCustom
  } = profiles;
  const label = active ? active.name : 'Custom (Current)';
  const icon = active ? active.icon : 'custom';
  return <>
      <div className="flex items-center gap-[8px] pb-[6px] pt-[9px]" data-id="element-544" data-mp="2s2gyeabbm8or">
        <div className="flex shrink-0 items-center gap-[5px]" data-id="element-545" data-mp="2x1tjapimt5op">
          <span className="text-[13.5px] font-bold text-pf-ink" data-id="element-546" data-mp="2x08snazfu6w4">Profile</span>
          <InfoTip label="Profiles store every auto support setting so you can switch between them" data-id="element-547" data-mp="31tlan29m3ffw" />
        </div>
        <div ref={rowRef} className="flex min-w-0 flex-1 items-center gap-[6px]" data-id="element-548" data-mp="35wrfc5h2syk9">
          <button type="button" aria-haspopup="menu" aria-expanded={menuOpen} aria-label={`Support profile: ${label}`} onClick={() => setMenuOpen(o => !o)} className={`flex h-[28px] min-w-0 flex-1 items-center gap-[7px] rounded-[5px] border bg-white pl-[8px] pr-[6px] text-[12px] text-pf-ink transition-colors duration-150 ${menuOpen ? 'border-pf-blue ring-2 ring-pf-blue/15' : 'border-pf-blue-line hover:border-pf-blue'}`} data-id="element-549" data-mp="295z1zflj1km6">
            
            <ProfileIcon icon={icon} className="h-[14px] w-[14px] shrink-0" data-id="element-550" data-mp="1yh2ztr5wxo93" />
            <span className="min-w-0 flex-1 truncate text-left" data-id="element-551" data-mp="1yj5vortqyblq">{label}</span>
            <ChevronDownIcon className={`h-[13px] w-[13px] shrink-0 transition-transform duration-150 ${menuOpen ? 'rotate-180' : ''}`} strokeWidth={2.4} data-id="element-552" data-mp="1uey32jk64bi8" />
          </button>
          <button type="button" aria-label="Save current settings as a profile" title="Save current as profile" onClick={() => {
          setMenuOpen(false);
          setModal('save');
        }} className="flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-[5px] border border-pf-line bg-white text-pf-ink transition-colors duration-150 hover:bg-pf-panel" data-id="element-553" data-mp="23h7fjeyzyey9">
            
            <SaveIcon className="h-[14px] w-[14px]" strokeWidth={2.2} data-id="element-554" data-mp="x03r8ilcjrjs" />
          </button>
        </div>
      </div>

      <AnchoredPopover anchorRef={rowRef} open={menuOpen} onClose={closeMenu} width={262} align="end" data-id="element-555" data-mp="s1is6mhtzdwx">
        <ProfileMenu presets={profiles.presets} saved={profiles.saved} activeId={active?.id ?? null} isCustom={isCustom} onPick={p => {
        profiles.applyProfile(p);
        setMenuOpen(false);
      }} onSaveNew={() => {
        setMenuOpen(false);
        setModal('save');
      }} onManage={() => {
        setMenuOpen(false);
        setModal('manage');
      }} data-id="element-556" data-mp="33nucwgt83yva" />
        
      </AnchoredPopover>

      <AnimatePresence data-id="element-557" data-mp="3rcvqeigwy07f">
        {modal === 'save' && <SaveProfileModal key="save" settings={profiles.settings} onCancel={() => setModal(null)} onSave={(name, ic) => {
        profiles.saveProfile(name, ic);
        setModal(null);
      }} data-id="element-558" data-mp="3rbknekvakwhd" />}
        {modal === 'manage' && <ManageProfilesModal key="manage" profiles={profiles.saved} onCancel={() => setModal(null)} onSave={list => {
        profiles.replaceSaved(list);
        setModal(null);
      }} data-id="element-559" data-mp="2213as28fp0w9" />}
      </AnimatePresence>
    </>;
}